import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Transformation, Image } from "cloudinary-react";

const useStyles = makeStyles((theme) => ({
  container: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
  },
  pictureContainer: {
    marginLeft: 30,
    marginTop: 20,
  },
  tableContainer: {
    flex: 1,
    [theme.breakpoints.up("lg")]: {
      maxWidth: "800px",
    },
  },
  table: {
    marginTop: 30,
  },
}));

const RanglisteComponent = ({ gemeinde, gemeindeliste }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h6">Platz</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6">Gemeinde</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" align="right">
                  Füllstand Kornspeicher
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {gemeindeliste
              ? gemeindeliste
                  .sort((a, b) => {
                    if (a.summe && b.summe) return b.summe - a.summe;
                    if (a.summe) return -1;
                    if (b.summe) return 1;
                    return 0;
                  })
                  .map((g, index) => {
                    const styling =
                      gemeinde && gemeinde.id === g.id
                        ? { fontWeight: "bold" }
                        : null;
                    return (
                      <TableRow key={g.id}>
                        <TableCell>
                          <Typography variant="body2" style={styling}>
                            {index + 1}.
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" style={styling}>
                            {g.name}, {g.ort}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body2" style={styling}>
                            {g.summe
                              ? g.summe.toLocaleString(navigator.language, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : 0}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })
              : null}
          </TableBody>
        </Table>
      </div>
      <div className={classes.pictureContainer}>
        <Image className={classes.logo} publicId="internal/ernte.png">
          <Transformation
            quality="auto"
            radius="20"
            width="200"
            height="250"
            crop="fill"
          />
        </Image>
      </div>
    </div>
  );
};

export default RanglisteComponent;
